export interface AdvancedReportToolbarProps {}

const AdvancedReportToolbar: React.FC<AdvancedReportToolbarProps> = ({}) => {
  return null;
};
export default AdvancedReportToolbar;
